import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router.js'
import locales from '@/locales.js'

const app = createApp(App)
app.config.globalProperties.$locale = locales.en
app.config.globalProperties.$currency = 'usd'
app.use(router).mount('#app')
